import {
  GetAllPartnersRequest,
  GetAllInvitesRequest,
} from './../services/traxpartners.service';
import { ViewMode } from '../domain/enums/view-mode.enum';

const INITIAL_STATE: FiltersState = {
  partnerFilters: {
    searchBy: '',
    type: -1,
    salesPersonContactId: -1,
    orderBy: '',
    pageSize: 10,
    pageNumber: 1,
    encrypted: true,
  },
  invitationsFilters: {
    searchBy: '',
    status: -1,
    orderBy: '',
    pageSize: 10,
    pageNumber: 1,
    encrypted: true,
  },
  partnerViewMode: {
    mode: ViewMode.LIST_VIEW,
  },
  invitationsViewMode: {
    mode: ViewMode.LIST_VIEW,
  },
  shopPartnerFilters: {
    supplierTypeId: -1,
    shopTypeId: -1,
    makeId: -1,
    dealerId: -1,
  },
};

const FILTERS = 'FILTERS';

export const FiltersActions = {
  INIT: `${FILTERS}.FILTERS_INIT`,
  SET_PARTNER_FILTERS: `${FILTERS}.SET_PARTNER_FILTERS `,
  SET_INVITATIONS_FILTERS: `${FILTERS}.SET_INVITATIONS_FILTERS `,
  SET_INVITATION_FILTER_STATUS: `${FILTERS}.SET_INVITATION_FILTER_STATUS `,
  SET_PARTNERS_TABLE_VIEW_MODE: `${FILTERS}.SET_PARTNERS_TABLE_VIEW_MODE`,
  SET_INVITATIONS_TABLE_VIEW_MODE: `${FILTERS}.SET_INVITATIONS_TABLE_VIEW_MODE`,
  SET_SHOP_PARTNER_FILTER: `${FILTERS}.SET_SHOP_PARTNER_FILTER`,
};

export function filtersReducer(
  state: FiltersState = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case FiltersActions.INIT:
      state = INITIAL_STATE;
      return state;
    case FiltersActions.SET_PARTNER_FILTERS:
      state.partnerFilters = action.payload;
      return state;
    case FiltersActions.SET_INVITATIONS_FILTERS:
      const aux = state.invitationsFilters.status;
      state.invitationsFilters = action.payload;
      state.invitationsFilters.status = aux;
      return state;
    case FiltersActions.SET_INVITATION_FILTER_STATUS:
      state.invitationsFilters.status = action.payload;
      state.invitationsFilters.pageNumber = 1;
      state.invitationsFilters.pageSize = 10;
      state.invitationsFilters.searchBy = '';
      return state;
    case FiltersActions.SET_PARTNERS_TABLE_VIEW_MODE:
      state.partnerViewMode.mode = action.payload;
      return state;
    case FiltersActions.SET_INVITATIONS_TABLE_VIEW_MODE:
      state.invitationsViewMode.mode = action.payload;
      return state;
    case FiltersActions.SET_SHOP_PARTNER_FILTER:
      state.shopPartnerFilters = action.payload;
      return state;
    default:
      return state;
  }
}

export interface FiltersState {
  partnerFilters?: GetAllPartnersRequest;
  invitationsFilters?: GetAllInvitesRequest;
  partnerViewMode?: ITableViewMode;
  invitationsViewMode?: ITableViewMode;
  shopPartnerFilters?: IShopPartnerFilters;
}

export interface INotificationsFilters {
  from?: string;
  to?: string;
  events?: string[];
  products?: string[];
  roNumber?: string;
  pageSize?: number;
  pageNumber?: number;
}

export interface ITableViewMode {
  mode: number;
}
export interface IShopPartnerFilters {
  supplierTypeId: number;
  shopTypeId: number;
  makeId?: number;
  dealerId?: number;
}
